import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import router from './router' 
import store from './store';
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Formatters from '@/utils/formatters'
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
//import { library } from '@fortawesome/fontawesome-svg-core';
//import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
//import { faBars, faUser, faBell } from '@fortawesome/free-solid-svg-icons';

//library.add(faBars, faUser, faBell);
const app = createApp(App);
//app.component('font-awesome-icon', FontAwesomeIcon);
app.use(store)
app.use(router)
app.use(Toast, {
    position: POSITION.BOTTOM_RIGHT,
});
app.use(VueSidebarMenu)
store.dispatch('auth/initializeStore').then(() => {
app.config.globalProperties.$formatters = Formatters;
    app.mount('#app');
});
